import React, { useState } from "react";
import * as styles from "./styles.module.scss";
import tw, { css } from "twin.macro";
import * as T from "~components/styles/Typography.jsx";
import * as A from "~components/styles/Animations.jsx";
import Grid from "~components/styles/Grid.jsx";
import PartnerCard from "../../PartnerCard";
import InfoModal from "../../InfoModal";

const PartnersSmall = ({ heading, subheading, partners }) => {
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoModalContent, setInfoModalContent] = useState("");

  return (
    <section className={styles.container}>
      <Grid>
        <div
          css={[
            css`
              ${A.Keyframes(`appear`, {
                delay: `0`,
                settings: `0.25s ${A.EASING_CUBIC} forwards`
              })}
            `,
            tw`col-span-full relative py-14 md:py-20`
          ]}
        >
          <div className={styles.content}>
            <div className={styles.text}>
              <T.Body className={styles.heading} font="h3">
                {heading}
              </T.Body>
              <T.Body className={styles.subheading} font="h5">
                {subheading}
              </T.Body>
            </div>

            <div className={styles.tiles}>
              {partners.map((partner, i) => (
                <PartnerCard
                  {...partner}
                  setShowInfoModal={setShowInfoModal}
                  setInfoModalContent={setInfoModalContent}
                  key={partner._key}
                />
              ))}
            </div>
          </div>
        </div>
      </Grid>

      <InfoModal
        closeModal={() => setShowInfoModal(false)}
        infoText={infoModalContent}
        active={showInfoModal}
      />
    </section>
  );
};

export default PartnersSmall;
